module.exports = __webpack_public_path__ + "img/testimonial-bg-570x420.31c9efa3.jpg";